
export class User {

    public employeeId: number;
    public employeeCode: string;
    public employeeName: string;
    public email: string;
    public mobileNo: string;
    public officeId: number;
    public officeName: string;
    public dealerId?: number;
   
    
    constructor() {
        this.employeeId = 0;
        this.employeeCode = "";
        this.employeeName = "";
        this.email = "";
        this.mobileNo = "";
        this.officeId = 0;
        this.officeName = "";
        
    }


}